<p-dialog
    [(visible)]="service.dialogVisible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [dismissableMask]="true"
    (onHide)="service.dismiss()"
    [style]="{ width: '32rem' }"
>
    <ng-template pTemplate="header">
        <div class="flex items-center gap-3">
            <div class="bg-primary-100 dark:bg-primary-900/30 flex h-10 w-10 items-center justify-center rounded-full">
                <i class="pi pi-phone text-primary-600 dark:text-primary-400 text-lg"></i>
            </div>
            <h3 class="text-surface-900 dark:text-surface-0 text-xl font-semibold">
                {{ 'COMMON.EXIT_INTENT.HEADER.DEFAULT' | translate }}
            </h3>
        </div>
    </ng-template>

    <div class="dark:bg-surface-800 border-surface-300 dark:border-surface-600 rounded-lg border bg-white px-6 py-4 text-center">
        <div class="mb-2 flex justify-center">
            <div class="bg-primary-500 dark:bg-primary-600 flex h-10 w-10 items-center justify-center rounded-full">
                <i class="pi pi-phone text-base text-white"></i>
            </div>
        </div>
        <p class="text-surface-700 dark:text-surface-200 mb-2 text-sm leading-relaxed">
            {{ 'COMMON.EXIT_INTENT.MESSAGE.DEFAULT' | translate }}
        </p>
        <a
            [href]="'tel:' + phoneNumberTel"
            class="text-primary-600 dark:text-primary-400 mb-3 block text-base font-semibold hover:underline"
        >
            {{ phoneNumber }}
        </a>
    </div>
</p-dialog>
